import { Link } from 'react-router-dom';
import { EmptyState } from '../components/EmptyState.js';
import { Icon } from '../components/Icon.js';
import { labels } from '../labels.js';

export function NotFoundPage() {
  return (
    <main style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}>
      <EmptyState icon="info" title="404" text={labels.errors.notFound}>
        <Link to="/" className="btn-primary">
          <Icon name="arrow-left" size={18} />
          {labels.errors.backHome}
        </Link>
      </EmptyState>
    </main>
  );
}
